import { ICommonStoreState } from 'model/interfaces';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  isSpinnerShow: false,
  langKey: 'en',
};
export const useCommonStore = create<ICommonStoreState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        updateSpinnerShow: (isSpinnerShow: boolean) => set({ isSpinnerShow }),
        updateLangKey: (langKey: string) => set({ langKey }),
      }),
      {
        name: 'kf1-commonStore', // Key name in sessionStorage
        storage: createJSONStorage((): Storage => window.sessionStorage), // Persist to sessionStorage
      },
    ),
  ),
);
